import { UniversitySliderCTA } from '../models/university-slider.models';

const currentYear = new Date().getFullYear();

export const UNI_SLIDER_COPY: UniversitySliderCTA = {
	// Course Profile
	course: {
		undergraduate: {
			studyType: 'Undergraduate',
			heading: 'Take your next step ✨',
			text: 'Your undergraduate journey starts here. Find out more about the course of your dreams.',
		},
		postgraduate: {
			studyType: 'Postgraduate',
			heading: 'Continue your university journey ✨',
			text: 'Discover the next steps for postgraduate study.',
		},
		clearing: {
			studyType: 'Clearing',
			heading: 'Clearing vacancies are available 🎉',
			text: 'Reserve your place now by calling the university or registering your interest',
		},
		nonClient: {
			studyType: 'Non-Client',
			heading: 'Discover more 👀',
			text: 'Learn more about this course.',
		},
	},
	// Uni Profile
	uni: {
		undergraduate: {
			studyType: 'Undergraduate',
			heading: 'Begin your journey here 🧭',
			text: 'Find out everything you need to know about your next home.',
		},
		postgraduate: {
			studyType: 'Postgraduate',
			heading: 'Take the next steps 🧭',
			text: 'Learn more about taking your journey.',
		},
		nonClient: {
			studyType: 'Non-Client',
			heading: 'Find out more',
			text: 'Learn more about this university here.',
		},
		noOpenDays: (uniName: string) => {
			return {
				studyType: 'All',
				heading: 'No events available…yet',
				text: `Unfortunately, there are currently no scheduled events with ${uniName}. But don't let that be the end of your journey!`,
			};
		},
		openDaysNonClient: (uniName: string) => {
			return {
				studyType: 'All',
				heading: `${currentYear} Open Days Not Available`,
				text: `There are no events available for ${uniName}, but you can find more open days with just one click.`,
			};
		},
	},
};
